import { Group, Stack, Text } from '@mantine/core'
import type { ConfirmLine } from '@/utils/autoScheduleConfirm'

export function ConfirmSummary({ lines }: { lines: ConfirmLine[] }) {
  return (
    <Stack gap={8}>
      {lines.map(line => (
        <Group key={line.label} justify="space-between" wrap="nowrap" gap="md">
          <Text size="sm" c="dimmed">
            {line.label}
          </Text>
          <Text size="sm" ta="right" style={{ fontVariantNumeric: 'tabular-nums' }}>
            {line.value}
          </Text>
        </Group>
      ))}
    </Stack>
  )
}
